// extracted by mini-css-extract-plugin
export default {"container":"Rl-z","blurb":"Sl-z","links":"Tl-z"};